import React, { useState } from "react";
import ReactMarkdown from "react-markdown";
import { Button, Collapse, Box } from "@material-ui/core";

export default function MarkdownExpand({
  text,
  limit = 200,
}) {
  const [expanded, setExpanded] = useState(false);

  const isLong = text.length > limit;
  const preview = isLong ? text.slice(0, limit) + "..." : text;

  return (
    <Box>
      <Collapse in={expanded} collapsedHeight={80}>
        <ReactMarkdown>
          {expanded ? text : preview}
        </ReactMarkdown>
      </Collapse>

      {isLong && (
        <Button
          color="primary"
          size="small"
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? "See Less" : "See More"}
        </Button>
      )}
    </Box>
  );
}
